// components/JobNumberBadge.jsx - Inline-Editable Job Number Badge
import React, { useState, useRef, useEffect } from 'react'
import { Pencil } from 'lucide-react'

export default function JobNumberBadge({ value, onChange, customerName, editing, onToggleEdit }) {
  const inputRef = useRef(null)
  const [localValue, setLocalValue] = useState(value)

  // Focus input when entering edit mode
  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus()
      inputRef.current.select()
    }
  }, [editing])

  // Update local value when prop changes
  useEffect(() => {
    setLocalValue(value)
  }, [value])

  const handleSave = () => {
    onChange(localValue)
    onToggleEdit()
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave()
    } else if (e.key === 'Escape') {
      setLocalValue(value) // Reset to original
      onToggleEdit()
    }
  }

  const handleBlur = () => {
    handleSave()
  }

  if (editing) {
    return (
      <input
        ref={inputRef}
        type="text"
        value={localValue}
        onChange={(e) => setLocalValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        className="text-xs px-2 py-1 border border-arbor-300 rounded bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-arbor-500"
        style={{ width: '140px' }}
        placeholder="Job number..."
      />
    )
  }

  return (
    <button
      onClick={onToggleEdit}
      className="group flex items-center gap-1.5 px-2.5 py-1 bg-gray-100 hover:bg-gray-200 rounded text-xs text-gray-600 hover:text-gray-900 transition-colors"
      title="Click to edit job number"
    >
      <span className="font-medium">{value}</span>
      <Pencil className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
    </button>
  )
}
